<div class="top-bar">
  <div class="d-flex justify-content-between align-items-center">
    <div>
      <app-icon (click)="toggleAside()" [cssStyle]="{ cursor: 'pointer' }" iconName="list" id="mobileSideMenuIcon" size="24px"></app-icon>
    </div>
    <div class="logo-wrapper">
      <img [src]="isHeadlineStandard ? 'assets/images/verein.png' : 'assets/images/verein-cloud.png'" alt="" routerLink="/m/dashboard" />
    </div>
    <div class="club-logo background-loading-tiny">
      <img [src]="logoUrl" alt="" appDefaultImage />
    </div>
  </div>
</div>
